import styled from 'styled-components';
import Button from 'bit/mobiauto.web-ui-components.components.button/Button';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: ${({ padding }) => (padding ? '16px' : '0px')};
`;

export const Text = styled.div`
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  padding-bottom: 20px;
  color: #757575;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const Row = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
`;

export const ConfirmButton = styled(Button)`
  background-color: #f44336 !important;
  font-family: Poppins Regular !important;
  text-transform: initial !important;
  margin-left: 4px !important;
`;

export const CancelButton = styled(ConfirmButton)`
  background-color: transparent !important;
  border: 1px solid #e0e0e0 !important;
  color: #333333 !important;
  margin-left: 0px !important;
  margin-right: 4px !important;
`;
